import { track } from '@fff-web/fff-analytics';
import { labelBySubscription } from '../../utils/labelBySubscription';
import getSwapAmountByPlanCode from '../../../../utils/getSwapAmountByPlanCode';
import {
  MY_ACCOUNT_EXPERIENCE,
  TRACK_NAME_LABEL,
  CANCEL_SUBSCRIPTION_LABEL,
  REACTIVATE_MEMBERSHIP_LABEL,
} from '../../../constants';

const CLICK_FOR_SWAP_EVENT_NAME = 'Swap Started';
const CLICK_FOR_SWAP_CTA_NAME = 'Swap for credit';

const CLICK_FOR_REACTIVATION_CTA_NAME = 'Reactivation Started';

const trackClickSwapForCredit = (userInfo) => {
  const properties = {
    swap_amount: getSwapAmountByPlanCode(userInfo.planCode),
    cta_name: CLICK_FOR_SWAP_CTA_NAME,
    experience: MY_ACCOUNT_EXPERIENCE,
  };
  track({ trackName: CLICK_FOR_SWAP_EVENT_NAME, properties }).finally(
    () => true
  );
};

const trackClickCancelSubscription = (user) => {
  const properties = {
    cta_name: CANCEL_SUBSCRIPTION_LABEL,
    experience: MY_ACCOUNT_EXPERIENCE,
    cancel_type: labelBySubscription(user?.planCode),
  };
  track({ trackName: TRACK_NAME_LABEL, properties }).finally(() => true);
};

const trackClickReactivateMembership = () => {
  const properties = {
    cta_name: REACTIVATE_MEMBERSHIP_LABEL,
    type: 'Expired Member',
    experience: MY_ACCOUNT_EXPERIENCE,
    reactivation_type: 'Expired',
  };
  track({ trackName: CLICK_FOR_REACTIVATION_CTA_NAME, properties }).finally(
    () => true
  );
};

export {
  trackClickSwapForCredit,
  trackClickCancelSubscription,
  trackClickReactivateMembership,
};
